import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var ReplacePipe = (function () {
    function ReplacePipe() {
    }
    ReplacePipe.prototype.transform = function (input, pattern, replacement) {
        if (!isString(input) || !pattern || !replacement) {
            return input;
        }
        return input.replace(pattern, replacement);
    };
    return ReplacePipe;
}());
export { ReplacePipe };
ReplacePipe.decorators = [
    { type: Pipe, args: [{
                name: 'replace'
            },] },
];
/** @nocollapse */
ReplacePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=replace.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/replace.pipe.js
// module id = 285
// module chunks = 103